module.exports = __webpack_public_path__ + "static/media/logo.88eeb51d.png";